import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, UpdateInveriteDialogueHandler } from './types';
import UpdateInveriteCpmtext from './UpdateInveriteContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type InveriteDialogueProps = {
  handleDialogue: DialogueHandler<UpdateInveriteDialogueHandler>;
};

type FC = FunctionComponent<InveriteDialogueProps>;

const UpdateInveriteDialogue: FC = ({ handleDialogue }: InveriteDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, UpdateError } = useContext(UpdateInveriteCpmtext);
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Inverite.Update.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title={t('UpdateError.title')}
          status="error"
          subTitle={`${UpdateError}`}
          confirm={{
            label: t('UpdateError.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title={t('UpdateSuccess.title')}
          status="success"
          subTitle={t('UpdateSuccess.subTitle')}
          confirm={{
            label: t('UpdateSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert],
  );
};

export default UpdateInveriteDialogue;
